module.exports = __webpack_public_path__ + "media/images/flags/ci-b1030b2b5315547c7fbe93c5dc5e8f78.svg";